import { render, staticRenderFns } from "./_milestone.vue?vue&type=template&id=bb4a40e0"
import script from "./_milestone.vue?vue&type=script&lang=js"
export * from "./_milestone.vue?vue&type=script&lang=js"
import style0 from "./_milestone.vue?vue&type=style&index=0&id=bb4a40e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports